import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  Input,
  Label,
  FormGroup,
  Form,
} from "reactstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import {
  addAIFadvPackage,
  getAIFadvPackageDataById,
  updateAIFadvPackage,
} from "model/AIFadvPackageModel";

/* -------------------- Yup Schema -------------------- */
const aiFadvPackageSchema = Yup.object().shape({
  fadvTitle: Yup.string().trim().required("Title is required"),
  buttonLabel: Yup.string().trim(),
  fadvPackage: Yup.string().trim(),
  fadvPosition: Yup.string().trim(),
  fadvDriver: Yup.string().trim(),
  fadvPackageType: Yup.string().trim(),
});

const AIFadvPackageAddEditModal = ({
  setAIFadvPackageAddEditModalOpen,
  aiFadvPackageAddEditModalOpen,
  getAIFadvPackageList,
  itemId,
  setFormData,
  formData,
}) => {
  const [formKey, setFormKey] = useState(0);
  const [errors, setErrors] = useState({});

  const closeModal = () => {
    setAIFadvPackageAddEditModalOpen(false);
    setErrors({});
  };

  /* -------------------- Change Handler -------------------- */
  const handleChange = async (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (!aiFadvPackageSchema.fields[name]) return;

    try {
      await Yup.reach(aiFadvPackageSchema, name).validate(value);
      setErrors((prev) => ({ ...prev, [name]: "" }));
    } catch (err) {
      setErrors((prev) => ({ ...prev, [name]: err.message }));
    }
  };

  /* -------------------- Submit -------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await aiFadvPackageSchema.validate(formData, { abortEarly: false });
      setErrors({});
    } catch (err) {
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      setErrors(newErrors);
      return;
    }

    const params = {
      fadvTitle: formData?.fadvTitle || "",
      buttonLabel: formData?.buttonLabel || "",
      fadvPackage: formData?.fadvPackage || "",
      fadvPosition: formData?.fadvPosition || "",
      fadvDriver: formData?.fadvDriver || "",
      fadvPackageType: formData?.fadvPackageType || "",
    };

    let response;
    if (itemId) {
      response = await updateAIFadvPackage(itemId, params);
    } else {
      response = await addAIFadvPackage(params);
    }

    if (response?.success) {
      toast.success(response?.message);
      closeModal();
      getAIFadvPackageList();
    } else {
      toast.error(response?.message);
    }
  };

  /* -------------------- Edit Fetch -------------------- */
  const getFetchAIFadvPackageById = async (id) => {
    const response = await getAIFadvPackageDataById({ Id: id });
    if (response?.data) {
      setFormData({
        fadvTitle: response?.data?.fadvTitle || "",
        buttonLabel: response?.data?.buttonLabel || "",
        fadvPackage: response?.data?.fadvPackage || "",
        fadvPosition: response?.data?.fadvPosition || "",
        fadvDriver: response?.data?.fadvDriver || "",
        fadvPackageType: response?.data?.fadvPackageType || "",
      });
      setFormKey((k) => k + 1);
    }
  };

  useEffect(() => {
    if (itemId) {
      getFetchAIFadvPackageById(itemId);
    }
  }, [itemId]);

  return (
    <Modal
      isOpen={aiFadvPackageAddEditModalOpen}
      toggle={closeModal}
      backdrop="static"
      className="modal-full-height"
      centered
    >
      <ModalBody
        key={formKey}
        className="p-4"
        style={{ maxHeight: "95vh", overflowY: "auto" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0 text-uppercase">
            {itemId ? "Update" : "Create"}
          </h5>
          <Button close onClick={closeModal} />
        </div>
        <hr />

        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>
              Title <span className="text-danger">*</span>
            </Label>
            <Input
              type="text"
              name="fadvTitle"
              defaultValue={formData?.fadvTitle}
              onChange={handleChange}
            />
            {errors.fadvTitle && (
              <small className="text-danger">{errors.fadvTitle}</small>
            )}
          </FormGroup>

          <FormGroup>
            <Label>ButtonLabel</Label>
            <Input
              type="text"
              name="buttonLabel"
              defaultValue={formData?.buttonLabel}
              onChange={handleChange}
            />
            {errors.buttonLabel && (
              <small className="text-danger">{errors.buttonLabel}</small>
            )}
          </FormGroup>

          <FormGroup>
            <Label>FadvPackage</Label>
            <Input
              type="text"
              name="fadvPackage"
              defaultValue={formData?.fadvPackage}
              onChange={handleChange}
            />
            {errors.fadvPackage && (
              <small className="text-danger">{errors.fadvPackage}</small>
            )}
          </FormGroup>

          <FormGroup>
            <Label>FadvPosition</Label>
            <Input
              type="text"
              name="fadvPosition"
              defaultValue={formData?.fadvPosition}
              onChange={handleChange}
            />
            {errors.fadvPosition && (
              <small className="text-danger">{errors.fadvPosition}</small>
            )}
          </FormGroup>

          <FormGroup>
            <Label>FadvDriver</Label>
            <Input
              type="text"
              name="fadvDriver"
              defaultValue={formData?.fadvDriver}
              onChange={handleChange}
            />
            {errors.fadvDriver && (
              <small className="text-danger">{errors.fadvDriver}</small>
            )}
          </FormGroup>

          <FormGroup>
            <Label>FadvPackageType</Label>
            <Input
              type="text"
              name="fadvPackageType"
              defaultValue={formData?.fadvPackageType}
              onChange={handleChange}
            />
            {errors.fadvPackageType && (
              <small className="text-danger">{errors.fadvPackageType}</small>
            )}
          </FormGroup>

          <div className="text-end mt-3">
            <Button color="primary" type="submit">
              {/* <i className="bx bx-save me-1" /> */}
              {itemId ? "Update" : "Save"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AIFadvPackageAddEditModal;
